<template>
    <div class="box" ref="box">
        <img src="@/assets/images/poster.jpg" class="background">
        <div ref="qrcode" class="qrcode"></div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import html2Canvas from 'html2canvas';

export default {
    mounted() {
        let size = this.$refs.box.clientWidth / 284 * 50 * 2;
        new QRCode(this.$refs.qrcode, {
            text: location.origin + (location.pathname.indexOf('xhdc') > -1 ? '/xhdc/' : '') + '?referrer=' + this.$store.state.user.uid,
            width: size,
            height: size,
        })
        setTimeout(() => {
            html2Canvas(this.$refs.box, {useCORS: true, windowWidth: 800, windowHeight: 800}).then(canvas => {
                this.$emit('ready', canvas.toDataURL('image/jpg', 1.0));
            })
        }, 300);
    }
};
</script>

<style scoped lang="scss">
.box {
    position: fixed;
    top: -100%;
    width: 284px;
    height: 424px;
    .background {
        display: block;
        width: 100%;
        height: 100%;
    }
    ::v-deep(.qrcode) {
        position: absolute;
        right: 8.4px;
        bottom: 17px;
        overflow: hidden;
        border-radius: 5px;
        img {
            width: 50px;
            height: 50px;
        }
    }
}
</style>
